export default __webpack_public_path__ + "static/media/customerSatisfaction.2a5414fb.jpg";